var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import api from "../utils/api";

import { Translate } from "../I18N";
import { SettingsHeader } from "../Settings/components/SettingsHeader";
import ActivitylogForm from "./components/ActivitylogForm";
import { ActivitylogList } from "./components/ActivitylogList";

export class ActivityLog extends RouteHandler {
  static async requestState(requestParams) {
    const logs = await api.get('activitylog', requestParams);
    return [
    actions.set('activitylog/search', logs.json),
    actions.set('activitylog/list', logs.json.rows)];

  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content without-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "activity-log panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Activity log")
      ), /*#__PURE__*/
      _jsx(ActivitylogForm, {}, void 0, /*#__PURE__*/
      _jsx(ActivitylogList, {})
      )
      )
      ));

  }
}

export default ActivityLog;